/**
 * titleCase — presentation-only capitalisation for stored lowercase labels
 * (card BlxH5uQRsEYQ, founder email 2026-10-22).
 *
 * Notebook kinds and subtypes are stored lowercase on purpose: the values are
 * keys (kind 'make', subtype 'recipes') that match the link taxonomy and stay
 * stable in D1. They were being rendered raw, so a recipe link's chip read
 * "recipes". This helper is what a person sees; the stored value never changes.
 *
 *   titleCase('recipes')            -> 'Recipes'
 *   titleCase('podcast-episodes')   -> 'Podcast Episodes'
 *   titleCase('how-to guides')      -> 'How-to Guides'
 *
 * Small words keep their case inside the phrase (ISO-ish style: only the first
 * word and proper nouns get the capital) so multi-word subtypes read the way a
 * person would write them.
 */
const SMALL = new Set(['a', 'an', 'the', 'and', 'or', 'of', 'for', 'to', 'in', 'on', 'at', 'vs']);

export function titleCase(raw: string | null | undefined): string {
  if (!raw) return '';
  const words = raw
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ');
  if (words.length === 0) return '';
  return words
    .map((word, i) => {
      const lower = word.toLowerCase();
      if (i > 0 && SMALL.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}
